import type { ReportedPost } from '@/domain/reports/entities/reported_post.entity'
import type { ReportedPostRepository } from '@/domain/reports/repositories/reported_post_repository'
import { ReportedPostsRtkDatasource } from '../datasources/reported_posts_rtk_datasource'

export class ReportedPostRepositoryImpl implements ReportedPostRepository {
  constructor(
    private readonly remote: ReportedPostsRtkDatasource = new ReportedPostsRtkDatasource()
  ) {}

  async list(): Promise<ReportedPost[]> {
    const items = await this.remote.list()
    return items.map(item => ({
      id: item.id,
      imageUrl: item.imageUrl ?? undefined,
      content: item.content,
      postedBy: item.postedBy,
      reportedBy: item.reportedBy,
      reason: item.reason,
      createdAt: item.createdAt,
    }))
  }

  async delete(reportId: string): Promise<void> {
    await this.remote.hideReportedPost(reportId)
  }
}

export const reportedPostRepository = new ReportedPostRepositoryImpl()
